module.exports = __webpack_public_path__ + "static/img/0002个人简历网站.94ad64b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0002个人简历网站.jpg
// module id = Aes3
// module chunks = 0